export const alphabet = new Array(26)
  .fill(1)
  .map((_, i) => String.fromCharCode(65 + i));
